/* Init commons */
window.bcl = window.bcl || {}; // Asegura que `bcl` existe en `window` sin redefinirlo si ya existe

["c", "u", "s"].forEach((prop) => (bcl[prop] = bcl[prop] || {}));
bcl.load = Object.prototype.hasOwnProperty.call(bcl, "load") ? bcl.load : false;

bcl.preInit = bcl.preInit || [];
